import React, { useEffect } from "react";
import { IAppPropsWithRoute } from "../../common/types";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showNavbar } from "../../store/modules/appStateSlice";
import ViewReasonsForRescheduleWidget from "./ViewReasonsForRescheduleWidget";

interface ViewReasonsForReschedulePageProps extends IAppPropsWithRoute {}

const ViewReasonsForReschedulePage = (
  props: ViewReasonsForReschedulePageProps
): JSX.Element => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showNavbar(true));
  }, [dispatch]);

  return <ViewReasonsForRescheduleWidget />;
};

export default React.memo(withRouter(ViewReasonsForReschedulePage));
